import script from "./Feedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=73d029de&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d029de"]])

export default __exports__